import { render, staticRenderFns } from "./SymbologyHistogram.vue?vue&type=template&id=18febdac&scoped=true"
import script from "./SymbologyHistogram.vue?vue&type=script&lang=js"
export * from "./SymbologyHistogram.vue?vue&type=script&lang=js"
import style0 from "./SymbologyHistogram.vue?vue&type=style&index=0&id=18febdac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18febdac",
  null
  
)

export default component.exports